export enum OrderClientStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    REJECTED = 'REJECTED',
    ACCEPTED = 'ACCEPTED',
    EXPIRED = 'EXPIRED',
    NON_SUCCESSFUL_SIGNATURE = 'NON SUCCESSFUL SIGNATURE',
}
